// Static content for the Contact Us page.
// Kept as plain data (instead of PageBuilder / hosted assets) so the page
// no longer depends on a fetched "contact-us" page asset.
//
// All prose is referenced by translation message id (see en.json / th.json,
// keys prefixed "ContactUsPage.") so the content can be localized.
// Email addresses and the registered address are kept as plain values and
// rendered as-is in every locale.

export const companyInfo = {
  name: 'Metta People Co., Ltd.',
  address: '41/1, Soi On Nut 36, On Nut Sub-district, Suan Luang District, Bangkok 10250, Thailand',
  email: 'info@mettapeople.com',
};

// Block types used below:
// p      -> paragraph, { id }
// box    -> bordered sub-section box, { titleId, bodyId?, email? }
//           bodyId is optional (some boxes are just a title + email link);
//           email, when present, is rendered as a mailto link inside the box
// note   -> italic note line, { id }
// office -> registered office block, plain name/address from companyInfo

export const contactSections = [
  {
    titleId: 'ContactUsPage.s1.title',
    accentBar: true,
    blocks: [
      {
        type: 'box',
        titleId: 'ContactUsPage.s1.box1.title',
        email: 'info@mettapeople.com',
      },
      {
        type: 'box',
        titleId: 'ContactUsPage.s1.box2.title',
        bodyId: 'ContactUsPage.s1.box2.body',
        email: 'info@mettapeople.com',
      },
      {
        type: 'box',
        titleId: 'ContactUsPage.s1.box3.title',
        bodyId: 'ContactUsPage.s1.box3.body',
        email: 'info@mettapeople.com',
      },
      {
        type: 'box',
        titleId: 'ContactUsPage.s1.box4.title',
        bodyId: 'ContactUsPage.s1.box4.body',
        email: 'info@mettapeople.com',
      },
      {
        type: 'box',
        titleId: 'ContactUsPage.s1.box5.title',
        bodyId: 'ContactUsPage.s1.box5.body',
        email: 'info@mettapeople.com',
      },
      { type: 'note', id: 'ContactUsPage.s1.responseTime' },
    ],
  },
  {
    titleId: 'ContactUsPage.s2.title',
    gradient: true,
    blocks: [{ type: 'office' }],
  },
];
